import { render, staticRenderFns } from "./mainLogo.vue?vue&type=template&id=29bcd032"
import script from "./mainLogo.vue?vue&type=script&lang=js"
export * from "./mainLogo.vue?vue&type=script&lang=js"
import style0 from "./mainLogo.vue?vue&type=style&index=0&id=29bcd032&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports